/**
 * @fileoverview PATCH handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/dimensions/:dimension/actions" endpoint.
 * Bulk-upserts action bank rows: a row carrying an action_id updates that
 * action, a row without one creates an action, and actions left out of the
 * list are untouched. Answers with one row per submitted row, in the order
 * sent, in the table shape.
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsCacheKeys } from "./constants";
import type {
  DecisioningStudioActionBankWriteError,
  PatchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsProps,
  PatchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsResult,
} from "./types";

export const patchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActions = reactQueryMutationAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsCacheKeys,
  createMutationFetcherFunctionWithShadowError<DecisioningStudioActionBankWriteError>()(
    (
      props: PatchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsProps
    ): Promise<PatchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsResult> => {
      return fetch(
        `/decisioning_studio_agents/${props.appGroupId}/${props.dsaId}/dimensions/${props.dimension}/actions`,
        "PATCH",
        {
          actions: props.actions,
        },
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  )
);
